// --- src/admin/contexts/ThemeContext.jsx ---
import React, { createContext, useState, useEffect } from 'react';
export const ThemeContext = createContext();
const themes = ['light', 'dark'];
export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('theme');
    return themes.includes(saved) ? saved : 'light';
  });
  useEffect(() => {
    document.documentElement.className = `theme-${theme}`;
    localStorage.setItem('theme', theme);
  }, [theme]);
  const toggleTheme = () => {
    const idx = themes.indexOf(theme);
    setTheme(themes[(idx + 1) % themes.length]);
  };
  return <ThemeContext.Provider value={{ theme, toggleTheme }}>{children}</ThemeContext.Provider>;
};